export const replaceTimestamps = (array1: any[], array2: any[]): any[] =>  {
  let result = [];
  let i: number = 0;
  let j: number = 0;

  while (i < array1.length && j < array2.length) {
    if (Math.abs(array1[i].timestamp - array2[j].timestamp) <= Math.abs(array1[i].timestamp - (array2[j + 1]?.timestamp || Infinity))) {
      result.push({ timestamp: array2[j].timestamp, price: array1[i].price });
      i++;
    } else {
      j++;
    }
  }
  return result;
}